module.exports = __webpack_public_path__ + "img/logo-small.19d7612f.svg";